import { Fragment } from "react";
import { useI18n } from "@wato/i18n/react";
import { legalLinks } from "./legal-links";

// Placeholders swapped for the two links after translation, so word order follows the locale.
const TERMS = "@@terms@@";
const PRIVACY = "@@privacy@@";

/** OWN-376 (60.6): «by creating an account you agree to the terms and privacy» under the submit button. */
export function SignupLegalLine({ pagesBaseUrl }: { pagesBaseUrl?: string }) {
  const { t } = useI18n();
  const links = legalLinks(pagesBaseUrl);
  const parts = t("dashboard.b29b.legal.agree", { terms: TERMS, privacy: PRIVACY }).split(
    /(@@terms@@|@@privacy@@)/,
  );
  return (
    <p className="text-center text-xs text-fg-muted" data-testid="signup-legal">
      {parts.map((part, i) => {
        if (part !== TERMS && part !== PRIVACY) return <Fragment key={i}>{part}</Fragment>;
        const isTerms = part === TERMS;
        return (
          <a
            key={i}
            className="underline"
            href={isTerms ? links.terms : links.privacy}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={isTerms ? "signup-legal-terms" : "signup-legal-privacy"}
          >
            {t(isTerms ? "dashboard.b29b.legal.terms" : "dashboard.b29b.legal.privacy")}
          </a>
        );
      })}
    </p>
  );
}
